import React from "react";
import {Box} from '@mui/material';
import CustomAppBar from '../components/appbar';
import PrivateList from "../components/privateBids";


const PrivateBids = () => {
    return (
        <Box>
            <CustomAppBar active="private"/>
            <PrivateList/>
        </Box>
    );
}

export default PrivateBids;